import { render, staticRenderFns } from "./BundleProducts.vue?vue&type=template&id=3e1abb3f&scoped=true&"
import script from "./BundleProducts.vue?vue&type=script&lang=ts&"
export * from "./BundleProducts.vue?vue&type=script&lang=ts&"
import style0 from "./BundleProducts.vue?vue&type=style&index=0&id=3e1abb3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1abb3f",
  null
  
)

export default component.exports